import { assessorApi } from '../baseConfig';
import { EngineResponse } from '../common.types';
import { IAnswerParams, IAnswerResponse, IApproveAnswerParams } from './assessorApi.types';

export const getQuestions = (params: IAnswerParams) => assessorApi.post('get-open-questions', { json: params }).json<EngineResponse<{ items:IAnswerResponse[], count:number }>>();

export const approveAnswer = (params: IApproveAnswerParams) => assessorApi.post('finish-open-question', { json: params });
